import { ActionConsts } from '@Definitions/index';

export const INITIAL_STATE = {
  allExternalReviews: [],
  stats: [],
  isLoading: false,
};

export const ExternalReviews = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionConsts.Reviews.GetAllExternalReviewsInit:
      return {
        ...state,
        isLoading: true,
      };
    case ActionConsts.Reviews.GetAllExternalReviewsSuccess:
      return {
        ...state,
        isLoading: false,
        allExternalReviews: action.allExternalReviews,
        stats: action.stats,
      };
    case ActionConsts.Reviews.GetAllExternalReviewsFail:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
